import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useUDCompareTopics( name1, name2 ) {
   return useFetchData({
      APIMethod: API.getUDCompareTopics,
      condition: !!name1 && !!name2,
      cache_name: `${name1}-${name2}-ud-compare-topics`,
      params: [ name1, name2 ]
   })
}
